import React from "react";
import "./Table.css";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  usePagination,
} from "react-table";
import { TiGroup } from "react-icons/ti";
import { BsPersonFill } from "react-icons/bs";
import {
  ChevronDoubleLeftIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ChevronDoubleRightIcon,
} from "@heroicons/react/solid";
import { GoSearch } from "react-icons/go";
import { Button, PageButton } from "./shared/Button";
import { classNames } from "./shared/Utils";
import { SortIcon, SortUpIcon, SortDownIcon } from "./shared/Icons";

export function SelectColumnFilter({
  column: { filterValue, setFilter, preFilteredRows, id, render },
}) {
  // Calculate the options for filtering
  // using the preFilteredRows
  const options = React.useMemo(() => {
    const options = new Set();
    preFilteredRows.forEach((row) => {
      options.add(row.values[id]);
    });
    return [...options.values()];
  }, [id, preFilteredRows]);
}
export function StatusPill({ value }) {
  const status = value ? value.toLowerCase() : "unknown";

  return (
    <span
      className={classNames(
        "px-3 py-1 uppercase leading-wide text-xs rounded-full shadow-sm",
        status.startsWith("active")
          ? "bg-green-100 text-white"
          : status.startsWith("discontinued")
          ? "bg-red-800 text-white"
          : null
      )}
    >
      {status}
    </span>
  );
}

export function AvatarCell({ value, column, row }) {
  return (
    <div className="flex items-center">
      <div className="flex-shrink-0 h-10 w-10">
        {row.original.assigned_to === "group" ? (
          <TiGroup className="mt-1.5" size={25} color="#1F78B4" />
        ) : (
          <BsPersonFill className="mt-1.5" size={25} color="#1F78B4" />
        )}
      </div>
      <div>
         <div className="text-sm font-medium text-gray-500">{row.original.assigned_to === "group" ?(row.original.group?.name):(row.original.staff?.name)}</div>
      </div>
    </div>
  );
}

export function NumberCell({ value, column, row }) {
  return (
    <div className="flex items-center">
      {console.log("col", column)}
      {console.log("row", value)}
      <div className="px-3 py-1 uppercase leading-wide rounded-full shadow-sm bg-cyan-100 text-blue-200 text-sm font-medium">
      { parseInt(row.id)+ 1}
      </div>
      <div>
        <div className="ml-2 text-sm font-medium text-gray-500">{value}</div>
      </div>
    </div>
  );
}

function Table({ columns, data }) {
  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state,
  } = useTable(
    {
      columns,
      data,
    },
    useSortBy,
    usePagination // new
  );

  // Render the UI for your table
  return (
    <>
      {/* table */}
      <div className="mt-10 shadow-lg rounded-lg flex flex-col font-Roboto overflow-x-hidden overflow-y-hidden">
        <div className="-my-2 overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-2 lg:px-4">
            <div className="overflow-hidden border-b border-t border-white bg-white sm:rounded-sm">
              <h2 className="ml-8 font-Montserrat text-base font-bold text-blue-200 mx-3 my-3">
                Schedule List
              </h2>
              <table {...getTableProps()} className="ml-8 min-w-full">
                <tbody {...getTableBodyProps()} className="bg-white">
                  {page.map((row, index) => {
                    // new
                    prepareRow(row);
                    return (
                      <tr {...row.getRowProps()} className="bg-white">
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="px-3 py-3 whitespace-nowrap data-cell-width"
                              role="cell"
                            >
                              {cell.column.Cell.name === "defaultRenderer" ? (
                                <div className="text-sm text-gray-500">
                                  {cell.render("Cell")}
                                </div>
                              ) : (
                                cell.render("Cell")
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot className="flex flex-row min-w-full justify-center my-4">
                  <button>
                    <h2 className="font-Montserrat text-base font-bold text-blue-200">
                      Show More
                    </h2>
                  </button>
                </tfoot>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Table;
